<div
  fxLayout="column"
  fxLayoutAlign="center center"
  fxLayoutGap="10px"
  class="filter-form-container"
>
  <ng-container [ngSwitch]="pageType">
    <h1 *ngSwitchCase="'apartamente-noi-rahova-salaj-sector5-bucuresti'">
      Garsoniere si apartamente noi in sectorul 5 de la dezvoltator
    </h1>
    <h1 *ngSwitchCase="'cartierul-nou-salaj'">
      Cartierul Nou Sălaj - Apartamente 2, 3 camere, Garsoniere de Vânzare
    </h1>
    <h1 *ngSwitchCase="'garsoniere-de-vanzare-rahova-sector-5'">
      Garsoniere de vânzare - Dream Residence (sector 5, Rahova)
    </h1>
    <h1 *ngSwitchCase="'apartamente-2-camere-de-vanzare-rahova-sector-5'">
      Apartamente 2 camere de vânzare - Dream Residence (sector 5, Rahova)
    </h1>
    <h1 *ngSwitchCase="'apartamente-3-camere-de-vanzare-rahova-sector-5'">
      Apartamente 3 camere de vânzare - Dream Residence (sector 5, Rahova)
    </h1>
    <h1 *ngSwitchDefault>
      Vedeți detalii despre apartamente de 2 camere, apartamente 3 camere și garsoniere de vânzare.
      <br>
      Complex rezidențial Dream Residence - Rahova (sector 5, zona Sebastian, Pucheni).
    </h1>
  </ng-container>
  <form>
    <div
      fxLayout="column"
      fxLayout.gt-sm="row"
      fxLayoutAlign="center center"
      class="buttons-wrapper"
    >
      <a
        mat-raised-button
        [color]="getPropertySearch().room_count == null ? 'black' : 'main-color'"
        [routerLink]="[pageType == 'apartamente-noi-rahova-salaj-sector5-bucuresti' ? '/cartierul-nou-salaj' : '/apartamente-noi-rahova-salaj-sector5-bucuresti']"
      >
        {{ 'pages.houses.room_filters.0' | translate }}
      </a>
      <a
        mat-raised-button
        [color]="getPropertySearch().room_count == 1 ? 'black' : 'main-color'"
        [routerLink]="['/garsoniere-de-vanzare-rahova-sector-5']"
      >
        {{ 'pages.houses.room_filters.1' | translate }}
      </a>
      <a
        mat-raised-button
        [color]="getPropertySearch().room_count == 2 ? 'black' : 'main-color'"
        [routerLink]="['/apartamente-2-camere-de-vanzare-rahova-sector-5']"
      >
        {{ 'pages.houses.room_filters.2' | translate }}
      </a>
      <a
        mat-raised-button
        [color]="getPropertySearch().room_count == 3 ? 'black' : 'main-color'"
        [routerLink]="['/apartamente-3-camere-de-vanzare-rahova-sector-5']"
      >
        {{ 'pages.houses.room_filters.3' | translate }}
      </a>
    </div>
  </form>
</div>

<div
  class="properties"
  id="list"
  (window:scroll)="onScroll()"
  #section
>
  <div
    *ngIf="apartmentTypes.length == 0 && !apiLoading"
  >
    {{ 'others.apartments.no_length' | translate }}
  </div>
  <div
    fxLayout="column"
    fxLayout.gt-xs="row wrap"
    fxLayoutAlign="center center"
    class="properties-list"
    *ngIf="apartmentTypes.length"
  >
    <a
      *ngFor="let apartmentType of apartmentTypes"
      class="property-item"
      [routerLink]="[basePath, 'tip-apartament', apartmentType.friendly_id]"
    >
      <app-my-apartment-type [apartmentType]="apartmentType"></app-my-apartment-type>
    </a>
  </div>
  <app-loading-spinner
    [apiLoading]="apiLoading"
  >
  </app-loading-spinner>
  <app-scroll-guide
    [conditions]="apartmentTypes && apartmentTypes.length && !endOfList && !apiLoading"
  >
  </app-scroll-guide>
</div>



// WEBPACK FOOTER //
// ./src/app/houses/houses.component.html